export function cellColor(r) {
  if(!r) return
  r = typeof r === 'string' ? r : r.level
  if(r === 'info') return 'rgba(63, 195, 128, 0.9)'
  if(r === 'error') return 'rgba(242, 38, 19, 0.9)'
  if(r === 'warning') return 'rgba(248, 148, 6, 0.9)'
  return 'rgba(242, 38, 19, 0.9)'
};
